import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      fill: "#FFB007"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.65474 11.3818C2.5602 11.3818 2.47293 11.3309 2.42202 11.2436C1.45475 9.57815 1.2802 7.59269 1.93475 5.78906C2.58929 3.98542 4.00748 2.57451 5.81111 1.92724C5.94929 1.87633 6.10929 1.94904 6.1602 2.0945C6.21111 2.23268 6.13839 2.39267 5.99293 2.44358C4.33475 3.03994 3.0402 4.32721 2.44384 5.98539C1.84747 7.64357 2.00747 9.45448 2.88747 10.9818C2.9602 11.1127 2.91657 11.2799 2.78566 11.3527C2.74202 11.3745 2.69838 11.389 2.64747 11.389L2.65474 11.3818Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.0216 12.96C11.9416 12.96 11.8689 12.9309 11.8107 12.8655C11.7162 12.7491 11.7307 12.5818 11.8398 12.48C12.6107 11.8255 13.1998 10.9746 13.5489 10.0219C13.898 9.06915 13.9926 8.0364 13.8253 7.04003C13.8035 6.89458 13.898 6.74913 14.0507 6.72731C14.1962 6.71277 14.3416 6.80004 14.3635 6.95276C14.5453 8.04367 14.4435 9.17094 14.0653 10.2182C13.6871 11.2655 13.0398 12.1964 12.1962 12.9091C12.1453 12.9528 12.0798 12.9746 12.0216 12.9746V12.96Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.5089 4.90909V6.27637H8.02886V7.37455H9.87614V8.66908H8.02886V11.0836H6.3125V5.62908C6.3125 5.22908 6.63977 4.90181 7.03977 4.90181H10.5089V4.90909Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }